import { render, staticRenderFns } from "./JourneyConnectionDeduplicationField.vue?vue&type=template&id=416d58c0&"
import script from "./JourneyConnectionDeduplicationField.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionDeduplicationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('416d58c0')) {
      api.createRecord('416d58c0', component.options)
    } else {
      api.reload('416d58c0', component.options)
    }
    module.hot.accept("./JourneyConnectionDeduplicationField.vue?vue&type=template&id=416d58c0&", function () {
      api.rerender('416d58c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/DeduplicationSettings/JourneyConnectionDeduplicationField.vue"
export default component.exports